import { render, staticRenderFns } from "./amz_rule.vue?vue&type=template&id=fa0d36e0&scoped=true&"
import script from "./amz_rule.vue?vue&type=script&lang=js&"
export * from "./amz_rule.vue?vue&type=script&lang=js&"
import style0 from "./amz_rule.vue?vue&type=style&index=0&id=fa0d36e0&scoped=true&lang=less&"
import style1 from "./amz_rule.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0d36e0",
  null
  
)

export default component.exports